var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnFileExplorer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.444,
    height: 82.998,
    viewBox: "0 0 105.444 82.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-file-explorer",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12264",
    "data-name": "Path 12264",
    d: "M91.138,1354.917q-13.7,0-27.395,0A7.958,7.958,0,0,1,56,1347.2q-.007-22.454,0-44.909a7.989,7.989,0,0,1,7.659-7.645q27.473,0,54.946,0a7.961,7.961,0,0,1,7.7,7.679q.011,22.454,0,44.909a7.988,7.988,0,0,1-7.7,7.687q-13.737.006-27.473,0Zm-30.123-40.181c-.012.263-.027.443-.027.622q0,16.056,0,32.111c0,1.691.8,2.459,2.543,2.46q27.591,0,55.181,0c1.866,0,2.611-.751,2.611-2.628q0-15.859,0-31.718v-.846ZM61,1309.67h60.32c0-2.454,0-4.857,0-7.26,0-2.092-.692-2.78-2.773-2.78H71.061c-2.564,0-5.128-.009-7.692.005-1.43.008-2.314.689-2.346,1.991C60.956,1304.289,61,1306.954,61,1309.67Z",
    transform: "translate(-34.948 -1283.047)",
    fill: "#347cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12266",
    "data-name": "Path 12266",
    d: "M292.188,1342.57q4.862,0,9.723,0a2.506,2.506,0,1,1,.035,4.983q-9.8.01-19.6,0a2.5,2.5,0,1,1,.043-4.984Q287.287,1342.566,292.188,1342.57Z",
    transform: "translate(-223.397 -1323.434)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12267",
    "data-name": "Path 12267",
    d: "M122.415,1342.583a2.492,2.492,0,1,1-2.511,2.471A2.511,2.511,0,0,1,122.415,1342.583Z",
    transform: "translate(-88.801 -1323.446)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12268",
    "data-name": "Path 12268",
    d: "M172.805,1345.087a2.491,2.491,0,1,1-2.481-2.5A2.51,2.51,0,0,1,172.805,1345.087Z",
    transform: "translate(-129.182 -1323.45)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12269",
    "data-name": "Path 12269",
    d: "M220.7,1345.047a2.492,2.492,0,1,1-2.5-2.48A2.5,2.5,0,0,1,220.7,1345.047Z",
    transform: "translate(-169.544 -1323.432)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12263",
    "data-name": "Path 12263",
    d: "M393.321,272.028c-3.692-1.052-5.32-2.6-5.559-6.209-.24,3.606-1.868,5.157-5.559,6.209,3.691,1.052,5.318,2.6,5.559,6.209C388,274.631,389.629,273.081,393.321,272.028Z",
    transform: "translate(-382.203 -239.455)",
    fill: "#00aafc",
    opacity: 0.376
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12262",
    "data-name": "Path 12262",
    d: "M411.564,236.113c-2.55-.727-3.674-1.8-3.839-4.29-.166,2.491-1.291,3.563-3.84,4.29,2.549.727,3.674,1.8,3.84,4.288C407.89,237.911,409.014,236.839,411.564,236.113Z",
    transform: "translate(-338.955 -157.403)",
    fill: "#00aafc",
    opacity: 0.376
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M329.763,213.514c-2.549-.727-3.674-1.8-3.839-4.289-.166,2.491-1.29,3.562-3.839,4.289,2.55.727,3.673,1.8,3.839,4.288C326.089,215.312,327.214,214.241,329.763,213.514Z",
    transform: "translate(-224.319 -179.02)",
    fill: "#00aafc",
    opacity: 0.376
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739-2",
    "data-name": "Path 739",
    d: "M329.763,213.514c-2.549-.727-3.674-1.8-3.839-4.289-.166,2.491-1.29,3.562-3.839,4.289,2.55.727,3.673,1.8,3.839,4.288C326.089,215.312,327.214,214.241,329.763,213.514Z",
    transform: "translate(-273.408 -209.225)",
    fill: "#00aafc",
    opacity: 0.376
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24446",
    "data-name": "Path 24446",
    d: "M1683.088,47.318l-3.145-3.147q-2.437-2.439-4.875-4.878a1.22,1.22,0,0,1-.057-1.737l.028-.035-2.809-2.81c-.189.139-.384.287-.584.426a11.219,11.219,0,0,1-5.294,2,11.4,11.4,0,0,1-9.612-3.354,11.229,11.229,0,0,1-3.214-6.2c-.064-.364-.094-.734-.141-1.1a1.089,1.089,0,0,0-.024-.107V24.792c.036-.289.066-.579.108-.867a11.611,11.611,0,0,1,11.4-9.984,11.617,11.617,0,0,1,11.5,9.225,11.387,11.387,0,0,1-2.33,9.742c-.011.015-.023.029-.034.044a.068.068,0,0,0-.007.016l2.8,2.795a1.223,1.223,0,0,1,1.184-.321,1.32,1.32,0,0,1,.629.388q2.871,2.871,5.742,5.74l2.29,2.291a.387.387,0,0,1,0,.506l-2.947,2.951Zm-18.1-12.545a9.193,9.193,0,1,0-9.185-9.187A9.192,9.192,0,0,0,1664.986,34.774Z",
    transform: "translate(-1609.735 23.264)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1623",
    "data-name": "Ellipse 1623",
    transform: "translate(42.722 35.255)",
    fill: "#fff",
    stroke: "#347cb5",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11.25,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFileExplorer);
export default __webpack_public_path__ + "static/media/icn-file-explorer.87fd27b6e9e7ae27ef4e6a5c12d0762a.svg";
export { ForwardRef as ReactComponent };